import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  position: relative;
  height: auto;
  min-height: 38px;
  margin: auto;
  font-family: ${(p) => p.theme.fonts.gtEesti};
  font-size: 16px;
  line-height: 18px;
  border: 1px solid ${(p) => p.theme.colors.secondary80w};
  border-radius: ${(p) => (p.isMenuOpen ? '10px 10px 0 0' : '10px')};
  background-color: ${(p) => (p.disabled ? p.theme.colors.secondary90w : 'transparent')};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'auto')};

  & * {
    background-color: ${(p) => (p.disabled ? p.theme.colors.secondary90w : 'transparent')};
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'auto')};
  }

  &:active,
  &:hover,
  &:focus {
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.white}, 0 0 0 3px ${(p) => p.theme.colors.primary};
  }

  ${(p) =>
    p.isFocused &&
    css`
      box-shadow: 0 0 0 2px ${(pp) => pp.theme.colors.white},
        0 0 0 3px ${(pp) => pp.theme.colors.primary};
    `}
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 36px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  outline: none;
  border-radius: 10px;
`;

export const SelectedItemsWrapper = styled.div`
  display: inline-flex;
  flex-flow: wrap;
  align-items: center;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  min-height: 36px;
  padding: 0;
  width: ${(p) => (p.visuallyHidden ? 0 : 'unset')};
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 10px;
  background-color: none;
  border: none;
`;

export const Loader = styled.button`
  position: absolute;
  right: 5px;
  background-color: none;
  border: none;
`;

export const MenuWrapper = styled.ul`
  margin: 0;
  padding: 0;
  border-top: 0;
  outline: none;
  position: absolute;
  right: 0;
  left: 0;
`;

export const Menu = styled.div`
  position: absolute;
  left: -1px;
  margin-top: 3px;
  width: calc(100% + 2px);
  max-height: 16em;
  min-height: 37px;
  overflow: auto;
  background-color: ${(p) => p.theme.colors.white};
  border: 1px solid ${(p) => p.theme.colors.secondary80w};
  border-radius: 0 0 10px 10px;
  z-index: ${(p) => p.theme.zIndexes.overlay};

  box-shadow: 0 0 0 2px ${(p) => p.theme.colors.white}, 0 0 0 3px ${(p) => p.theme.colors.primary};
`;

export const Item = styled.li`
  list-style: none;
  padding: 8px 20px;
  font-weight: ${(p) => (p.bold ? 'bold' : 'unset')};
  background-color: ${(p) => (p.highlighted ? p.theme.colors.primary95w : p.theme.colors.white)};
    color: ${(p) => p.theme.colors.secondary};
`;

export function styles(theme, style, maxViewItems, error) {
  return {
    container: (provided) => ({
      ...provided,
      ...style,
      fontFamily: theme.fonts.gtEesti,
      fontSize: 16,
      lineHeight: '18px',
    }),
    dropdownIndicator: () => ({
      paddingRight: 20,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 18px',
    }),
    control: (provided, { isFocused, menuIsOpen }) => ({
      ...provided,
      boxShadow: isFocused
        ? `0 0 0 2px ${theme.colors.white}, 0 0 0 3px ${theme.colors.primary}`
        : 'none',
      borderRadius: 10,
      borderBottomLeftRadius: menuIsOpen ? 0 : 10,
      borderBottomRightRadius: menuIsOpen ? 0 : 10,
      borderColor: error ? theme.colors.danger : theme.colors.secondary80w,
      '&:hover': {
        borderColor: error ? theme.colors.danger : theme.colors.secondary80w,
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: 14,
      color: theme.colors.secondary80w,
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: 14,
      color: theme.colors.secondary80w,
      textAlign: 'left',
      padding: '8px 20px',
    }),
    option: (provided, { isSelected, isFocused }) => ({
      ...provided,
      padding: '8px 20px',
      margin: 0,
      fontWeight: isSelected ? 'bold' : 'normal',
      backgroundColor: isSelected || isFocused ? theme.colors.primary95w : 'white',
      '&:hover': {
        backgroundColor: theme.colors.primary95w,
      },
      color: 'black',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      margin: 0,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      maxHeight: maxViewItems * 34,
      zIndex: 5,
    }),
    menu: (provided) => ({
      ...provided,
      padding: 0,
      margin: 0,
      borderRadius: 0,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      border: `1px solid ${theme.colors.secondary80w}`,
      borderTop: 'none',
      overflow: 'hidden',
      zIndex: 5,
      boxShadow: `0 0 0 2px ${theme.colors.white}, 0 0 0 3px ${theme.colors.primary}`,
    }),
  };
}
